import _sfc_main from "./FlowListbox.vue2.js";
import "./FlowListbox.vue3.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const FlowListbox = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-e0fbc367"]]);
export {
  FlowListbox as default
};
//# sourceMappingURL=FlowListbox.vue.js.map
